// src/pages/micuenta/ConfiguracionSeguridad.jsx
import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { FaArrowLeft, FaLock, FaShieldAlt } from "react-icons/fa";
import "./configuracionseguridad.css";

function ConfiguracionSeguridad() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordMessage, setPasswordMessage] = useState("");
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!user) {
    return (
      <div className="config-container">
        <div className="config-card">
          <h2 className="config-title">Cargando usuario...</h2>
        </div>
      </div>
    );
  }

  const handleBack = () => {
    navigate("/mi-cuenta");
  };

  const handlePasswordChange = (e) => {
    setNewPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleChangePassword = (e) => {
    e.preventDefault();
    // Si el usuario inició sesión con un provider distinto a "local"
    if (user.provider && user.provider !== "local") {
      setPasswordMessage(
        `No puedes cambiar la contraseña directamente porque iniciaste sesión con ${user.provider.toUpperCase()}.`
      );
      return;
    }
    // Validación básica: que ambas contraseñas coincidan
    if (newPassword !== confirmPassword) {
      setPasswordMessage("Las contraseñas no coinciden.");
      return;
    }
    // Aquí podrías agregar la llamada a tu API para cambiar la contraseña.
    setPasswordMessage("Contraseña actualizada correctamente.");
  };

  const handleToggleTwoFactor = () => {
    // Aquí iría la lógica para activar/desactivar 2FA (llamada a API, etc.)
    setTwoFactorEnabled((prev) => !prev);
  };

  return (
    <div className="config-container">
      <div className="config-card">
        {/* Botón para regresar a Mi Cuenta */}
        <button className="back-button" onClick={handleBack}>
          <FaArrowLeft className="back-icon" /> Regresar a Mi Cuenta
        </button>

        <h2 className="config-title">Configuración de Seguridad</h2>

        {/* Sección: Cambiar Contraseña */}
        <div className="config-section">
          <h3 className="section-title">
            <FaLock className="section-icon" /> Cambiar Contraseña
          </h3>
          {user.provider && user.provider !== "local" ? (
            <p className="info-message">
              No puedes cambiar la contraseña directamente, ya iniciaste sesión
              con <strong>{user.provider.toUpperCase()}</strong>.
            </p>
          ) : (
            <form onSubmit={handleChangePassword} className="config-form">
              <div className="form-group">
                <label>Nueva Contraseña</label>
                <input
                  type="password"
                  className="form-control"
                  value={newPassword}
                  onChange={handlePasswordChange}
                  placeholder="Ingresa la nueva contraseña"
                  required
                />
              </div>
              <div className="form-group">
                <label>Confirmar Contraseña</label>
                <input
                  type="password"
                  className="form-control"
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                  placeholder="Confirma la nueva contraseña"
                  required
                />
              </div>
              {passwordMessage && (
                <p className="message">{passwordMessage}</p>
              )}
              <button type="submit" className="btn-primary">
                Cambiar Contraseña
              </button>
            </form>
          )}
        </div>

        {/* Sección: Autenticación de Dos Factores */}
        <div className="config-section">
          <h3 className="section-title">
            <FaShieldAlt className="section-icon" /> Autenticación de Dos Factores
          </h3>
          <p className="info-message">
            {twoFactorEnabled
              ? "La autenticación de dos factores está activada."
              : "La autenticación de dos factores está desactivada."}
          </p>
          <button onClick={handleToggleTwoFactor} className="btn-primary">
            {twoFactorEnabled ? "Desactivar 2FA" : "Activar 2FA"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfiguracionSeguridad;